module.exports = __webpack_public_path__ + "img/gonghao-qr.345b5f12.jpg";